<template>
    <div class="m-radio-scoped">
        <v-radio-group class="m-radio-scoped" v-model="isChecked">
            <v-radio :value="true" :ripple="!isCustomAnimation" :class="{ 'customAnimation': isCustomAnimation }">
                <p slot="label" class="mb-0" :style="{ color: isChecked ? 'var(--dark)' : 'var(--darkgray)' }">{{ label }}</p>
            </v-radio>
        </v-radio-group>
    </div>
</template>

<script>
  /**
   * Esse componente serve apenas para ser usado sem radio-group
   */

  export default {
    name: 'MRadio',
    props: {
      value: [String, Number, Object],
      radioValue: [String, Number, Object],
      label: String,
      comparador: Object,
      isCustomAnimation: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isChecked: {
        get () {
          if (this.value instanceof Object) {
            return isEqualObjects(this.value, this.radioValue, this.comparador)
          } else {
            return this.value === this.radioValue
          }
        },
        set (checked) {
          if (checked) {
            this.$emit('input', this.radioValue)
          }
        }
      }
    }
  }

  /**
   *
   * @param a Object
   * @param b Object
   * @returns {boolean}
   */
  function isEqualObjects (a, b, comparador) {
    if (comparador) {
      for (const key in comparador) {
        // noinspection JSUnfilteredForInLoop
        const a_value = a[key]
        // noinspection JSUnfilteredForInLoop
        const b_value = b[key]
        // Se o valor de uma propriedade é um objeto, então verifica se são objetos diferentes,
        // se não é um objeto, usa o operador !== para verificar se são valores diferentes
        if ((a_value instanceof Object && !isEqualObjects(a_value, b_value)) || (!(a_value instanceof Object) && a_value !== b_value)) {
          return false
        }
      }
    } else {
      // Se tem um número diferente de chaves, então é diferente
      if (Object.keys(a).length !== Object.keys(b).length) {
        return false
      }

      for (const key in a) {
        // noinspection JSUnfilteredForInLoop
        const a_value = a[key]
        // noinspection JSUnfilteredForInLoop
        const b_value = b[key]
        // Se o valor de uma propriedade é um objeto, então verifica se são objetos diferentes,
        // se não é um objeto, usa o operador !== para verificar se são valores diferentes
        if ((a_value instanceof Object && !isEqualObjects(a_value, b_value)) || (!(a_value instanceof Object) && a_value !== b_value)) {
          return false
        }
      }
    }

    return true
  }
</script>

<style lang="scss">
.m-radio-scoped {
  .v-messages {
    display: none;
  }
}

.customAnimation {
  .v-input--selection-controls__input {
    input:hover {
      &~i::before {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 50%;
        padding: 5px;
        margin-left: -5px;
        cursor: hover;
      }
    }
  }

}
</style>
